export default class LogActivityActions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static GET_HELPER_LOGACTIVITY='GET_HELPER_LOGACTIVITY';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static RESET_LIST='RESET_LIST';
    static APPROVE='APPROVE';
    static REJECT='REJECT';
    static submit(){
      return {
        type: LogActivityActions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: LogActivityActions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: LogActivityActions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: LogActivityActions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: LogActivityActions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: LogActivityActions.SHOW_DATA,
        payload: data
      };
    }
    static resetList() {
      return {
        type: LogActivityActions.RESET_LIST
      };
    }
    static error(error){
      return {
        type: LogActivityActions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: LogActivityActions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: LogActivityActions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: LogActivityActions.RESET_DATA,
      };
    }
    static helper(data){
      return {
        type: LogActivityActions.GET_HELPER_LOGACTIVITY,
        payload:data
      };
    }
    static errorInternal(error){
      return {
        type: LogActivityActions.ERROR_SERVER,
        payload: error
      };
    }
    static approve() {
      return {
        type: LogActivityActions.APPROVE
      };
    }
    static reject() {
      return {
        type: LogActivityActions.REJECT
      };
    }
  }